import { Outlet } from "react-router-dom";
import { AnnouncementBanner } from "../ui/AnnouncementBanner";
import { Footer } from "./Footer";
import { Navbar } from "./Navbar";

export function PublicLayout() {
  return (
    <>
      <AnnouncementBanner id="v2-launch">
        KuberCoin v2.0 is here — explore the new SDK Playground!
      </AnnouncementBanner>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}
